import qs from 'qs'
import { ApiParams } from '../../../../types/commonTypes'
import {
  AddInterviewerDetails,
  CheckInterviewerAvailabilityProps,
  CheckInterviewerAvailabilityResponse,
  DepartmentWiseEmployeesList,
  GetAllInterviewersDetails,
  getJobCode,
  InterviewerListAPIData,
} from '../../../../types/Recruitment/InterviewerConfiguration/interviewerConfigurationTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import {
  interviewerConfigurationApiConfig,
  AllowedHttpMethods,
} from '../../apiList'

const getDepartmentWiseEmployeesList = async (
  departmentName: string,
): Promise<DepartmentWiseEmployeesList[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: interviewerConfigurationApiConfig.getDepartmentWiseEmployeesList,
    method: AllowedHttpMethods.get,
    params: {
      departmentName,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const addInterviewerDetails = async (
  data: AddInterviewerDetails,
): Promise<AddInterviewerDetails> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: interviewerConfigurationApiConfig.addInterviewerDetails,
    method: AllowedHttpMethods.post,
    data,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const updateInterviewerDetails = async (
  data: AddInterviewerDetails,
): Promise<AddInterviewerDetails> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: interviewerConfigurationApiConfig.updateInterviewerDetails,
    method: AllowedHttpMethods.post,
    data,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getAllJobCodes = async (): Promise<getJobCode[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: interviewerConfigurationApiConfig.getAllJobCodes,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getAllInterviewersDetails = async (
  data: GetAllInterviewersDetails,
): Promise<InterviewerListAPIData> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: interviewerConfigurationApiConfig.getAllInterviewersDetails,
    method: AllowedHttpMethods.get,
    params: {
      fromDate: data?.fromDate,
      toDate: data?.toDate,
      jobCode: data?.jobCode,
      department: data?.department,
      EmployeeId: data?.EmployeeId,
      startIndex: data?.startIndex,
      endIndex: data?.endIndex,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const deleteInterviewerDetails = async (
  id: number,
): Promise<string | number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: interviewerConfigurationApiConfig.deleteInterviewerDetails,
    method: AllowedHttpMethods.delete,
    params: {
      id,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const deleteCheckedInterviewerDetails = async (
  interviewerId: number[],
): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: interviewerConfigurationApiConfig.deleteCheckedInterviewerDetails,
    method: AllowedHttpMethods.delete,
    params: { interviewerId },
    paramsSerializer: (params: ApiParams) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const isInterviewerAvailable = async (
  data: CheckInterviewerAvailabilityProps,
): Promise<CheckInterviewerAvailabilityResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: interviewerConfigurationApiConfig.isInterviewerAvailable,
    method: AllowedHttpMethods.get,
    params: {
      interviewDate: data.interviewDate,
      interviewTime: data.interviewTime,
      interviewerName: data.interviewerName,
      interviewCycleId: data.interviewCycleId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const interviewerConfigurationApi = {
  getDepartmentWiseEmployeesList,
  addInterviewerDetails,
  getAllJobCodes,
  getAllInterviewersDetails,
  deleteInterviewerDetails,
  updateInterviewerDetails,
  deleteCheckedInterviewerDetails,
  isInterviewerAvailable,
}

export default interviewerConfigurationApi
